import { apiService } from '@/services/APIService';

export default {

  deleteDocument(id) {
    return apiService.delete(`/documents/${id}`);
  },

  getRegionFolders(params) {
    return apiService.get('/region/document-folders', params);
  },

  createRegionFolder(params) {
    return apiService.post('/region/document-folders', params);
  },

  updateRegionFolder(id, params) {
    return apiService.put(`/region/document-folders/${id}`, params);
  },

  deleteRegionFolder(id) {
    return apiService.delete(`/region/document-folders/${id}`);
  },

  addDocumentToRegionFolder(id, params) {
    return apiService.put(`/region/document-folders/${id}/add`, params);
  },

  deleteDocumentFromRegionFolder(id, params) {
    return apiService.delete(`/region/document-folders/${id}/remove`, { data: params });
  },

  getAllRegionDocuments(params) {
    return apiService.get('/region/documents', params);
  },

  createRegionDocument(params) {
    return apiService.post('/region/documents', params);
  },

  deleteRegionDocument(id) {
    return apiService.delete(`/region/documents/${id}`);
  },

  getDocumentTypes() {
    return apiService.getCached('/region/document-uses/types');
  },

  getDocumentUses(params) {
    return apiService.get('/region/document-uses', params);
  },

  createDocumentUses(params) {
    return apiService.post('/region/document-uses', params);
  },

  updateDocumentUses(id, params) {
    return apiService.put(`/region/document-uses/${id}`, params);
  },

  deleteDocumentUses(id) {
    return apiService.delete(`/region/document-uses/${id}`);
  },

  getPublicDocumentPolicies(params) {
    return apiService.get('/public/policies/', params);
  },
};
